/**
 * @file   src\components\CWCheckbox.tsx
 * @brief  Checkobx component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { InputProperty } from '../interfaces/generalInterface';
import { Form } from '../utils/thirdpartyComponents';
import "../components/CWInput.scss";

const CWCheckbox = ({
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  label,
  isMandatory,
  autoFocus,
  errorMessage,
  value,
  id,
  name,
  type,
  accept,
  pattern,
  placeholder,
  disabled,
  maxLength,
  step,
  checked,
  helptext
}: InputProperty) => {

  return (
    <div className="form-group cw-check">
      <Form.Check
        name={name}
        type="checkbox"
        id={id}
        onChange={onChange}
        disabled={disabled}
        label={label}
        checked={checked}
      />
      {helptext ? <small className="help-text">{helptext}</small> : null}
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
  </div>
  );
};

export default CWCheckbox;
